// Define base parameters
const baseSearchParameters = {
  query_by: "title, title_embed",
  sort_by: "_text_match:desc,title:asc,location_count:desc",
  exclude_fields: "title_embed",
};

// Define vector query parameters with different k values
const vectorQueryParams = {
  default: "title_embed:([], distance_threshold:0.71, k:50)",
  map: "title_embed:([], distance_threshold:0.71, k:250)",
};

// Export the default parameters
export const additionalSearchParameters = {
  ...baseSearchParameters,
  vector_query: vectorQueryParams.default,
};

// Function to get parameters with specific vector query setting
export function getAdditionalSearchParameters(viewMode = "default") {
  return {
    ...baseSearchParameters,
    vector_query:
      viewMode === "map" ? vectorQueryParams.map : vectorQueryParams.default,
  };
}
